import React, { useState } from 'react';
import './SideBarHeader.css';
import InnerHeader from '../../InnerHeader';
import { StudentInnerHeader } from '../../StudentInnerHeader';

const SideBarHeader = ({ mode, book }) => {
  const [highlightedSection, setHighlightedSection] = useState(null);
  const [writingActivity] = useState(false);
  const [creatingActivity] = useState(undefined);
  const lastBookId = localStorage.getItem('lastBookId');

  return (
    <div style={{ display: 'block' }}>
      {mode === 'grade-mode' ? (
        <InnerHeader lastBookId={lastBookId} book={book} highlightedSection={highlightedSection} writingActivity={writingActivity} creatingActivity={creatingActivity} />
      ) : (
        <div className='sidebarheader_wrapper' style={{ display: 'block', padding: '0px 24px' }}>
          <StudentInnerHeader highlightedSection={highlightedSection} writingActivity={writingActivity} creatingActivity={creatingActivity} />
        </div>
      )}
    </div>
  );
};
export default SideBarHeader;
